import type { Movie, StreamingContent, WatchableContent } from "src/lib/movieinfo/movieinfotypes";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isMovie(t?: any): t is Movie {
    return t?.__typename === "Movie";
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isStreamingContent(t?: any): t is StreamingContent {
    if (process.env.NEXT_PUBLIC_DISABLE_SG === "true") return false;
    return t?.__typename === "StreamingContent";
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isWatchableContent(t?: any): t is WatchableContent {
    return t?.__typename === "WatchableContent";
}